export default "__VITE_ASSET__D50mOeqd__"